import { administrationApiSdk } from '../sdk/administrationClient.js';

import { defineCollectionStore } from './collectionStore.js';

/**
 * Auction Houses — the venues sales run at.
 *
 * The widest surface of the five, and the only noun a caller can reach by
 * something other than an identifier: `loadBySlug` reads the four-character
 * short name a person types or shares.
 *
 * Registration and house-tier knockout are two separate things on the same
 * dealership, and both are here because both are the house's. A house may bar
 * beyond its Operation's list and can never un-bar what the Operation barred, so
 * `restoreRegisteredDealership` lifts only what this house set.
 */
export const useAuctionHousesStore = defineCollectionStore({
    id: 'administration-auction-houses',
    client: administrationApiSdk.auctionHouses,
    extend({ client, holdCurrent }) {
        /** Read one house by its four-character slug, into `current`. */
        async function loadBySlug(slug) {
            return await holdCurrent(function () {
                return client.readBySlug(slug);
            });
        }

        return {
            loadBySlug,

            setLegalCompany: (id, companyId) => holdCurrent(() => client.setLegalCompany(id, companyId)),
            setBillingCompany: (id, companyId, subscriptionId) => holdCurrent(
                () => client.setBillingCompany(id, companyId, subscriptionId)
            ),
            setOperation: (id, operationId) => holdCurrent(() => client.setOperation(id, operationId)),
            setPolicy: (id, policyName, policy) => holdCurrent(() => client.setPolicy(id, policyName, policy)),
            clearPolicy: (id, policyName) => holdCurrent(() => client.clearPolicy(id, policyName)),
            setKnockedOutHumans: (id, humans) => holdCurrent(() => client.setKnockedOutHumans(id, humans)),
            registerDealership: (id, dealershipId) => holdCurrent(() => client.registerDealership(id, dealershipId)),
            unregisterDealership: (id, dealershipId) => holdCurrent(() => client.unregisterDealership(id, dealershipId)),
            knockOutRegisteredDealership: (id, dealershipId) => holdCurrent(
                () => client.knockOutRegisteredDealership(id, dealershipId)
            ),
            restoreRegisteredDealership: (id, dealershipId) => holdCurrent(
                () => client.restoreRegisteredDealership(id, dealershipId)
            )
        };
    }
});

export default useAuctionHousesStore;
